export const API = Object.freeze({
  AUTHENTICATION: {
    LOGIN_USER: 'web/j_security_check',
    LOGIN_GUEST_USER: 'api/registration/guest',
    USER_INFO: 'api/userinfo',
    PROFILE: 'api/profile'
  }
});
